import { IProvider } from '../../types/provider';

export const groupProviderToCsv = (data: IProvider[]) => {
    const groupData: any = [
        ['id', 'Full Name', 'Total of sessions', 'Total of sessions confirmed on time', '% of confirmed on time'],
    ];

    data.forEach((it) => {
        groupData.push([
            it.id,
            it.fullName,
            it.sessionScheduledByNow,
            it.sessionConfirmedInTimeSessionByNow,
            it.sessionConfirmPercentage,
        ]);
    });

    return groupData;
};
